import React, {
  useState,
  useEffect,
  useTransition,
  useLayoutEffect,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  _getChatList,
  _getChatMessages,
  _getUnreadMessages,
  _get_user_profile,
  _google_login,
  _google_logout,
  _seenMessages,
} from "src/DAL";
import { baseUri, s3baseUrl } from "src/config";
import {
  del_from_local_storage,
  get_from_localStorage,
  logout_user,
  set_to_localStorage,
  truncateText,
} from "src/utils";
import socketIOClient from "socket.io-client";
import { useSnackbar } from "notistack";
import { logoSmall } from "src/assets";
import {
  _notificationList,
  _notificationUnreadCount,
} from "src/DAL/notifications";
import { ConstructionOutlined } from "@mui/icons-material";
import {
  signInWithGoogle,
  signOutFromGoogle,
} from "src/pages/dashboard/components/googleAuth";
import moment from "moment";
import { _get_active_task_list } from "src/DAL/dashboard";
import { useRef } from "react";
import {
  del_from_sessionStorage,
  get_from_sessionStorage,
  set_to_sessionStorage,
} from "src/utils/sessionStorage";
import { capitalize } from "lodash";
// import { connect_socket, getSocket } from "./socket";
const Context = React.createContext();
const AppContext = ({ children }) => {
  const { pathname } = useLocation();
  const [profile, setProfile] = useState({
    first_name: "",
    last_name: "",
    email: "",
    image: "",
    contact_number: "",
    biography: "",
    gender: "",
  });
  const { enqueueSnackbar } = useSnackbar();
  const [searchValue, setSearchValue] = useState("");
  const [currentSelectedItem, setCurrentSelectedItem] = useState(undefined);
  const [globalSearchVisible, setGlobalSearchVisible] = useState(false);
  const [isPending, startTransition] = useTransition();
  const [key, setKey] = useState("");
  const [keyLoading, setKeyLoading] = useState(true);
  const [badge, setBadge] = useState({
    chat: 0,
    invitation: 0,
    support: 0,
  });
  const [planLimits, setPlanLimits] = useState({
    workspace_count: 0,
    project_count: 0,
    team_manager_count: 0,
    client_count: 0,
    total_team_count: 0,
  });
  const [currentPlan, setCurrentPlan] = useState({});
  const [limitReachedDialogOpen, setLimitReachedDialogOpen] = useState(false);
  const [noSubscriptionDialog, setNoSubscriptionDialog] = useState(false);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [logoutRadioValue, setLogoutRadioValue] = useState("0");
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState();
  const [startSocket, setStartSocket] = useState(false);
  //------------------------------------------------------

  const dispatch_get_user_profile = () => {
    return profile;
  };
  const dispatch_set_user_profile = (value) => {
    setProfile(value);
  };
  const dispatch_set_plan_limits = (limits) => {
    setPlanLimits(limits);
  };
  const dispatch_get_plan_limits = () => {
    return planLimits;
  };
  const dispatch_set_current_plan = (plan) => {
    setCurrentPlan(plan);
  };
  const dispatch_get_current_plan = () => {
    return currentPlan;
  };
  const dispatch_get_search_value = () => {
    return searchValue;
  };
  const dispatch_set_search_value = (value) => {
    setSearchValue(value);
  };
  const dispatch_get_current_selected_item = () => {
    return currentSelectedItem;
  };
  const dispatch_set_current_selected_item = (value) => {
    setCurrentSelectedItem(value);
  };
  const dispatch_get_search_visibility = () => {
    return globalSearchVisible;
  };
  const dispatch_set_search_visibility = (value) => {
    setGlobalSearchVisible(value);
  };
  //------------------------------------------------------
  useLayoutEffect(() => {
    if (get_from_localStorage("user")) {
      setProfile(get_from_localStorage("user"));
    }
    return () => {
      //cleanup
    };
  }, []);
  useEffect(() => {
    if (get_from_localStorage("workspaces")) {
      if (!pathname.includes("/workspaces")) {
        del_from_local_storage("workspaces");
      }
    }
    if (
      !pathname.includes("/workspaces/") &&
      get_from_localStorage("projects")
    ) {
      setSlugProjectsData([]);
      del_from_local_storage("projects");
    }
    if (
      !pathname.includes("/invoices") &&
      get_from_localStorage("invoiceTab")
    ) {
      del_from_local_storage("invoiceTab");
    }
  }, [useNavigate()]);

  const showSnackbar = (result) => {
    enqueueSnackbar(result.message, {
      variant: result.code == 200 ? "success" : "error",
    });
  };

  const showCustomSnackbar = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  //=========================Notifications===============================================================

  const [notifications, setNotifications] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const getNotificationList = async (pg = 0, limit = 50, filters = null) => {
    pg !== 0 && setLoading(true);
    const result = await _notificationList(pg, limit, filters);
    console.log(result, "notifications list");
    if (result.code == 200) {
      const temp = result.notification_list.notification.map((notification) => {
        return {
          ...notification,
          isUnRead: !notification.is_seen,
        };
      });
      setNotifications((prev) => {
        return pg ? prev.concat(temp) : temp;
      });
      setPage(pg + 1);
      const totalCount = result.notification_list.notification_count;
      if (pg === 0 && temp.length < limit) {
        setCount(temp.length);
      } else {
        setCount(totalCount);
      }
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setLoading(false);
  };

  //=========================Page Title====================================================

  const [pageTitle, setPageTitle] = useState({ title: "", show: true });

  /////////////////////////////////////////////////////////////////////////////////////////
  ///////////////===========Desktop Notifications==========================================

  const desktopNotification = (title, body, link) => {
    try {
      if ("Notification" in window && "hidden" in document) {
        // Request permission for displaying notifications
        Notification.requestPermission()
          .then(function (permission) {
            if (permission === "granted" && document.hidden) {
              // Create a new notification when the tab is hidden
              var notification = new Notification(title, {
                body: body,
              });

              // Optional: Handle click event on the notification
              notification.onclick = function () {
                if (link) {
                  window.location.href = link;
                  window.focus();
                } else {
                  window.focus();
                }
              };
            }
          })
          .catch(function (error) {
            console.error("Notification permission denied:", error);
          });
      } else {
        console.log("Notifications are not supported in this browser.");
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.log(error);
    }
  };

  useEffect(() => {
    try {
      if ("Notification" in window && Notification.permission !== "granted") {
        Notification.requestPermission();
      } else {
        console.log("Notifications are not allowed");
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.log(error);
    }
  }, []);

  ///===================Notifications==============================================
  const [notificationCount, setNotificationCount] = useState(0);
  const [unreadNotification, setUnreadNotification] = useState(0);
  const getNotificationCount = async () => {
    if (result.code == 200) {
      setNotificationCount(result.unread_notification_count);
      setBadge((prev) => {
        return {
          ...prev,
          chat: result.message_count.totall_unread_message_count,
          invitation: result.message_count.total_invitation_count,
        };
      });
    }
  };
  // useEffect(() => {
  //   get_from_localStorage("token") && getNotificationCount();
  // }, [profile]);

  const [slugProjectsData, setSlugProjectsData] = useState(
    // get_from_localStorage("projects") ??
    {
      loadMoreUrl: "",
      projects: [],
      count: 0,
    }
  );

  /////////////////////////////NEW CHAT/////////////////////////////////////////////
  const [messageList, setMessageList] = useState([]);
  const [chatData, setChatData] = useState();
  const [messageCount, setMessageCount] = useState(0);
  const [messageListPageNo, setMessageListPageNo] = useState(0);
  const [chatListDrawerOpen, setChatListDrawerOpen] = useState(false);
  const [isOpenChatDialog, setIsOpenChatDialog] = useState(false);
  const [isOpenChatNotificationDialog, setIsOpenChatNotificationDialog] =
    useState(false);
  const [isMinimizeChat, setIsMinimizeChat] = useState(false);
  const [isUserSeeningMessage, setIsUserSeeningMessage] = useState(false);
  const [loadingMessageList, setLoadingMessageList] = useState(false);
  const [chatListLoading, setChatListLoading] = useState(false);
  // const [currentChat, setCurrentChat] = useState(
  //   get_from_localStorage("currentChat")
  //     ? get_from_localStorage("currentChat")
  //     : null
  // );
  const [currentChat, setCurrentChat] = useState(
    get_from_sessionStorage("currentChat")
      ? get_from_sessionStorage("currentChat")
      : null
  );
  const [chatList, setChatList] = useState([]);
  const [chatCount, setChatCount] = useState(0);
  const [chatType, setChatType] = useState(
    get_from_localStorage("chatType")
      ? get_from_localStorage("chatType")
      : "all"
  );
  const isOpenChatDialogRef = useRef(isOpenChatDialog);
  const isMinimizeChatRef = useRef(isMinimizeChat);
  const pathnameRef = useRef(pathname);

  useEffect(() => {
    set_to_localStorage("chatType", chatType);
    currentChat && set_to_sessionStorage("currentChat", currentChat);
  }, [chatType, currentChat]);
  useEffect(() => {
    if (currentChat) {
      if (!pathname.startsWith("/chats")) {
        setIsOpenChatDialog(true);
        setChatType("all");
      } else {
        setIsOpenChatDialog(false);
      }
    } else {
      setIsOpenChatDialog(false);
    }
  }, [currentChat, pathname]);

  useEffect(() => {
    isOpenChatDialogRef.current = isOpenChatDialog;
    isMinimizeChatRef.current = isMinimizeChat;
    pathnameRef.current = pathname;

    if ((isOpenChatDialog && !isMinimizeChat) || pathname.startsWith("/chats")) {
      if (currentChat) {
        setCurrentChat((prev) => {
          return {
            ...prev,
            unread_count: 0,
          };
        });
      }
    }
  }, [isOpenChatDialog, isMinimizeChat, pathname]);

  //////////////////Functions////////////////////
  const getModifiedChatItem = (chat) => {
    if (chat.type == "0") {
      return {
        type: chat.type,
        creator_id: chat.chat_creator_id,
        label:
          chat.opposite_user?.first_name + " " + chat.opposite_user?.last_name,
        image:
          chat.opposite_user?.image !== ""
            ? s3baseUrl + chat.opposite_user?.image
            : "",
        _id: chat._id,
        is_online:
          chat.opposite_user?.mobile_app_status.online == "1" ||
          chat.opposite_user?.web_portal_status.online == "1",
        user: chat.opposite_user ? [chat.opposite_user] : null,
        unread_count: chat.unread_count,
        last_message: chat.last_message,
        member_user: chat.member_user,
      };
    } else if (chat.type == "1") {
      return {
        type: chat.type,
        label: chat.group_name,
        creator_id: chat.chat_creator_id,
        image: chat.group_image !== "" ? s3baseUrl + chat.group_image : "",
        _id: chat._id,
        user: chat.member_user,
        unread_count: chat.unread_count,
        last_message: chat.last_message,
        member_user: chat.member_user,
      };
    }
  };
  const getUnreadCount = async () => {
    const result = await _getUnreadMessages();
    if (result.code == 200) {
      setBadge((prev) => {
        return {
          ...prev,
          chat: result.message_count.totall_unread_message_count,
          invitation: result.message_count.total_invitation_count,
        };
      });
    }
  };
  //////////////////////////////////////////////
  const onSocketConnection = (data) => {
    console.log("Connected to server");
    setStartSocket(true);
    // fetch the unread count immediately - shamroz
    if (profile && profile.user_id && socket) {
      socket.emit("send_unread_count", { user_id: profile.user_id });
    }
  };
  const onSocketDisconnect = (reason) => {
    console.log("Disconnected from server:", reason);
    setStartSocket(false);
  };
  const generateUniqueIdForMessage = () => {
    let id = moment().format("x") * Math.random();
    return id.toString();
  };

  const showDesktopNotificationOfChat = (data) => {
    const fullName = `${data.message_sender.first_name} ${data.message_sender.last_name}`;
    let content = "";
    if (data?.image && !data?.audio_duration) {
      content = "🖼 Image";
    } else if (data?.image && data.audio_duration) {
      content = "🔉 Audio";
    } else {
      content = capitalize(truncateText(data?.text, 35));
    }
    desktopNotification(fullName, content);
  };

  const moveChatToTop = (data) => {
    console.log("chatlist updated no: 1");
    setChatList((prev) => {
      const index = prev.findIndex((chat) => chat._id === data.chat_id);
      if (index === -1) return prev;
      const temp = prev[index];
      for (let i = index; i > 0; i--) {
        prev[i] = prev[i - 1];
      }
      prev[0] = temp;
      return prev;
    });
  };

  const handleMinimizedChatMessage = (data) => {
    console.log("chatlist updated no: 2");
    setChatList((prev) =>
      prev.map((chat) =>
        chat._id === data.chat_id
          ? {
            ...chat,
            unread_count: chat.unread_count + 1,
            last_message: { ...data },
          }
          : { ...chat }
      )
    );

    setCurrentChat((prev) => ({
      ...prev,
      unread_count: prev.unread_count + 1,
    }));

    setMessageList((prev) => [data, ...prev]);
  };

  const handleActiveChatMessage = (data) => {
    if (data.sender_id === profile.user_id) {
      console.log(
        "Received Data from Socket and now updating the Message List"
      );
      setMessageList((prev) =>
        prev.map((message) =>
          message.temp_id === data.temp_id ? { ...data } : { ...message }
        )
      );
    } else {
      setMessageList((prev) => [data, ...prev]);
      setCurrentChat((prev) => ({
        ...prev,
        unread_count: prev.unread_count + 1,
      }));
    }
    setMessageCount((prev) => prev + 1);
    console.log("chatlist updated no: 3");
    setChatList((prev) =>
      prev.map((chat) =>
        chat._id === data.chat_id
          ? {
            ...chat,
            last_message: { ...data },
            member_user: chat.member_user.map((user) => ({
              ...user,
              unread_messages_count: data.unread_users.includes(user.user_id)
                ? user.unread_messages_count + 1
                : user.unread_messages_count,
            })),
          }
          : { ...chat }
      )
    );

    if (data.sender_id !== profile.user_id && data.chat_id === chatData?._id) {
      setChatData((prevChatData) => ({
        ...prevChatData,
        member_user: prevChatData.member_user.map((user) => ({
          ...user,
          unread_messages_count:
            user.user_id !== data.sender_id
              ? user.unread_messages_count + 1
              : 0,
        })),
      }));
    }
  };

  const addMessageSocket = async (data) => {
    console.log("Data received from socket", data);
    if (data.sender_id !== profile.user_id) {
      console.log(data.sender_id, profile.user_id, "pppppppp");
      showDesktopNotificationOfChat(data);
    }
    if (pathname.startsWith("/chats") || isOpenChatDialogRef.current) {
      moveChatToTop(data);
      if (data.chat_id == currentChat?._id) {
        if (isOpenChatDialogRef.current && isMinimizeChatRef.current) {
          handleMinimizedChatMessage(data);
        } else {
          handleActiveChatMessage(data);
          setIsUserSeeningMessage(true);
          // _seenMessages(currentChat._id);
        }
      } else {
        console.log("chatlist updated no: 4");
        setChatList((prev) => {
          return prev.map((chat) => {
            if (chat._id == data.chat_id) {
              return {
                ...chat,
                unread_count: (chat.unread_count || 0) + 1,
                last_message: { ...data },
              };
            } else {
              return { ...chat };
            }
          });
        });
      }
    } else {
      enqueueSnackbar("New message received!", { variant: "info" });
      // Update chat list even when not on chats page
      setChatList((prev) => {
        return prev.map((chat) => {
          if (chat._id == data.chat_id) {
            return {
              ...chat,
              unread_count: (chat.unread_count || 0) + 1,
              last_message: { ...data },
            };
          } else {
            return { ...chat };
          }
        });
      });
      // enqueueSnackbar(
      //   <span>
      //     <strong>{`${data.message_sender.first_name} ${data.message_sender.last_name}`}</strong><br />
      //     {
      //       (data?.image && !data?.audio_duration) ? "🖼 Image" :
      //       (data?.image && data.audio_duration) ? "🔉 Audio" :
      //       capitalize(truncateText(data?.text, 35))
      //     }
      //   </span>,
      //   { variant: "info" }
      // );
    }
    if (data.chat_id != currentChat?._id) {
      setBadge((prev) => {
        return {
          ...prev,
          chat: prev.chat + 1,
        };
      });
    }
  };
  const updatedMessageReceiver = (data) => {
    // let findedMessage = messageList.find((item) => {
    //   return item._id == data._id
    // });
    // if (findedMessage && findedMessage.text == data.text) {
    //   console.log("same same", findedMessage, data);
    //   const fullName = `${data.message_sender.first_name} ${data.message_sender.last_name}`;
    //   let content = "";
    //   if (data?.image && !data?.audio_duration) {
    //     content = "🖼 Image";
    //   } else if (data?.image && data.audio_duration) {
    //     content = "🔉 Audio";
    //   } else {
    //     content = capitalize(truncateText(data?.text, 35))
    //   }
    //   desktopNotification(fullName, content);
    // }
    console.log(data, "Editing Message response from socket");

    socketEmit("send_unread_count", { user_id: profile.user_id });
    if (
      (pathname.startsWith("/chats") || isOpenChatDialog) &&
      currentChat?._id == data.chat_id
    ) {
      setMessageList((prev) => {
        return prev.map((message) => {
          if (message._id == data._id) {
            return {
              ...message,
              text: data.text,
              // message_reactions: data.message_reactions,
            };
          } else {
            return { ...message };
          }
        });
      });
    }
  };
  const handleAddReaction = async (data) => {
    // let findedMessage = messageList.find((item) => {
    //   return item._id == data._id
    // });
    // if (findedMessage && findedMessage.text == data.text) {
    //   console.log("same same", findedMessage, data);
    //   const fullName = `${data.message_sender.first_name} ${data.message_sender.last_name}`;
    //   let content = "";
    //   if (data?.image && !data?.audio_duration) {
    //     content = "🖼 Image";
    //   } else if (data?.image && data.audio_duration) {
    //     content = "🔉 Audio";
    //   } else {
    //     content = capitalize(truncateText(data?.text, 35))
    //   }
    //   desktopNotification(fullName, content);
    // }
    console.log("Response of Socket event while Adding the Reaction", data);

    if (
      (pathname.startsWith("/chats") || isOpenChatDialog) &&
      currentChat?._id == data?.message_data?.chat_id
    ) {
      setMessageList((prev) => {
        console.log("Updating MessageList....");
        const updatedMessages = prev.map((message) => {
          if (message?._id == data?.message_data?._id) {
            return {
              ...message,
              message_reactions: data?.message_data?.message_reactions,
            };
          } else {
            return { ...message };
          }
        });
        return [data?.alert_data, ...updatedMessages];
      });
      setChatData(data?.chat_data);

      let res = await _seenMessages(currentChat._id);
      if (res.code === 200) {
        let receivers = currentChat.member_user;
        let receviverIds = receivers?.map((member) => {
          return member.user_id;
        });
        socketEmit("on_message_read", {
          chat_id: currentChat._id,
          receivers_id: receviverIds,
        });
      }
    }
    console.log("chatlist updated no: 93");
    setChatList((prev) =>
      prev.map((chat) =>
        chat._id === data?.chat_data._id
          ? { ...chat, last_message: { ...data?.alert_data } }
          : chat
      )
    );
  };

  const handleRemoveReaction = (data) => {
    console.log("Response of Socket event while Removing the Reaction", data);
    let filteredMessages = [];
    // socketEmit("send_unread_count", { user_id: profile.user_id });
    if (
      (pathname.startsWith("/chats") || isOpenChatDialog) &&
      currentChat?._id == data?.message_data?.chat_id
    ) {
      setMessageList((prev) => {
        console.log("Updating MessageList....");
        const updatedMessages = prev.map((message) => {
          if (message?._id == data?.message_data?._id) {
            return {
              ...message,
              message_reactions: data?.message_data?.message_reactions,
            };
          } else {
            return { ...message };
          }
        });
        filteredMessages = updatedMessages.filter((msg) => {
          return msg._id !== data?.alert_message._id;
        });
        return [...filteredMessages];
      });
      setChatData(data?.chat_data);
    }
    setChatList((prev) =>
      prev.map((chat) =>
        chat._id === data?.chat_data._id
          ? { ...chat, last_message: { ...filteredMessages[0] } }
          : chat
      )
    );
  };

  const handleSeenChatMessages = (data) => {
    console.log("Received Data from seen message socket event", data);
    if (currentChat?._id == data?._id) {
      setChatData(data);
    }
  };
  const deleteMessageReceiver = (data) => {
    console.log(data, "Response of Delete Message Socket");
    if (pathname.startsWith("/chats") || isOpenChatDialog) {
      let updatedList = [];
      if (currentChat?._id == data?.message_detail.chat_id) {
        setChatData(data?.chat_detail);
        setMessageList((prev) => {
          updatedList = prev.filter((msg) => {
            const deletingMessage = msg._id === data?.message_detail._id;

            const deletingReactions =
              msg?.message_type !== "general" &&
              (msg?.reply_message_detail?._id === data?.message_detail?._id ||
                msg?.reply_message_id === data?.message_detail?._id);

            return !deletingMessage && !deletingReactions;
          });
          setMessageCount(
            (count) => count - (prev.length - updatedList.length)
          );
          return updatedList;
        });
        console.log("chatlist updated no: 225");
        setChatList((prev) =>
          prev.map((chat) =>
            chat._id === data?.chat_detail._id
              ? { ...chat, last_message: { ...updatedList[0] } }
              : chat
          )
        );
      } else if (
        data?.message_detail.unread_users.find((id) => id == profile.user_id)
      ) {
        console.log("chatlist updated no: 5");
        setChatList((prev) =>
          prev.map((chat) => {
            if (chat._id === data?.chat_detail?._id) {
              return {
                ...chat,
                member_user: data?.chat_detail?.member_user,
                unread_count: chat.unread_count - 1,
              };
            } else {
              return chat;
            }
          })
        );
      }
    }
  };
  const deleteChat = (data) => {
    if (pathname.startsWith("/chats")) {
      if (currentChat?._id == data._id) {
        setMessageList([]);
        setMessageCount(0);
        setCurrentChat();
        del_from_sessionStorage("currentChat");
      }
      console.log("chatlist updated no: 6");
      setChatList((prev) => {
        return prev.filter((chat) => chat._id !== data._id);
      });
      setChatCount((prev) => prev - 1);
    }
  };
  const addChat = (data) => {
    console.log(data, "Data Received From Socket after creating chat or Group");
    if (pathname.startsWith("/chats")) {
      console.log(chatType, "OOOOOOOOOOOOOOOOOOOOO");
      if (chatType == "all") {
        console.log("chatlist updated no: 7");
        setChatList((prev) => {
          console.log(prev, "rrrrrrrrrrrr");
          return [getModifiedChatItem(data), ...prev];
        });
      } else {
        if (data.type == "1") {
          console.log("chatlist updated no: 8");
          setChatList((prev) => {
            return [getModifiedChatItem(data), ...prev];
          });
        }
      }
    }
  };
  const receiveUpdateNewChat = (data) => {
    if (pathname.startsWith("/chats")) {
      if (currentChat?._id == data._id) {
        setCurrentChat(getModifiedChatItem(data));
      }
      console.log("chatlist updated no: 9");
      setChatList((prev) => {
        return prev.map((chat) => {
          if (chat._id == data._id) {
            return { ...getModifiedChatItem(data) };
          } else {
            return { ...chat };
          }
        });
      });
    }
  };
  const userStatusChange = (data) => {
    if (pathname.startsWith("/chats") && chatType == "all") {
      if (
        currentChat?.user[0].user_id == data.user_id &&
        currentChat?.type == "0"
      ) {
        setCurrentChat((prev) => {
          return {
            ...prev,
            user: [data],
            is_online:
              data.mobile_app_status.online == "1" ||
              data.web_portal_status.online == "1",
          };
        });
      }
      if (chatType == "all") {
        console.log("chatlist updated no: 10");
        setChatList((prev) => {
          return prev.map((chat) => {
            if (chat.type == "0" && chat.user[0].user_id == data.user_id) {
              return {
                ...chat,
                user: [data],
                is_online:
                  data.mobile_app_status.online == "1" ||
                  data.web_portal_status.online == "1",
              };
            } else {
              return { ...chat };
            }
          });
        });
      }
    }
  };
  const receiveNotification = (data) => {
    socketEmit("send_unread_count", { user_id: profile.user_id });
    if (data.is_mute === false) {
      desktopNotification("Done Workspace", data.message, data.link);
      enqueueSnackbar(data.message, { variant: "info" });
    } else {
      return;
    }
    getNotificationList(); // get notifictaions when socket receive notification
    // setNotificationCount((prev) => prev + 1);
    // getNotificationCount();
    // getUnreadCount();
  };
  const receiveUnreadCount = (data) => {
    console.log("receive unread count >>>>");
    setNotificationCount(data.unread_count);
    setUnreadNotification(data.notification_count);
    setBadge((prev) => {
      return {
        ...prev,
        chat: data.message_count.totall_unread_message_count,
        invitation: data.message_count.total_invitation_count,
        support: data.unread_support_ticket_count,
      };
    });
  };

  useEffect(() => {
    console.log(chatList, "chatList changed .................");
  }, [chatList]);
  //////////////////////////////////////////////////////////////////////////////////
  ///===============Socket.io=========================================================
  const [socket, setSocket] = useState({
    emit: () => { },
    on: () => { },
    off: () => { },
    disconnect: () => { },
    connected: false,
    connecting: false,
  });
  const connectSocket = (user_id) => {
    const ENDPOINT = `${baseUri}?userId=${user_id}&type=${1}`;
    setSocket(
      socketIOClient(ENDPOINT, {
        transports: ["websocket", "polling"],
        // transports: ["polling", "websocket"],
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 500,
        reconnectionDelayMax: 2000,
        // reconnectionDelayMax: 10000,
      })
    );

    setStartSocket(true);
    console.log("socket connection initiated");
  };
  const socketEmit = (name, data) => {
    socket.emit(name, data);
  };
  const disconnectSocket = () => {
    socket.disconnect();
  };
  useEffect(() => {
    if (startSocket) {
      //socketEmit(`create`, profile.user_id.trim());
    }
  }, [startSocket]);
  const listenersArray = [
    {
      listener: "connect",
      action: onSocketConnection,
    },
    { listener: "chatMessage", action: addMessageSocket },
    {
      listener: "disconnect",
      action: onSocketDisconnect,
    },
    { listener: "userStatus", action: userStatusChange },
    {
      listener: "receiveDeleteMessage",
      action: deleteMessageReceiver,
    },
    {
      listener: "editMessageReceive",
      action: updatedMessageReceiver,
    },
    {
      listener: "on_reaction_add_message_detail",
      action: handleAddReaction,
    },
    {
      listener: "on_reaction_remove_message_detail",
      action: handleRemoveReaction,
    },

    {
      listener: "chat_detail_on_message_read",
      action: handleSeenChatMessages,
    },
    {
      listener: "receiver_notification",
      action: receiveNotification,
    },
    {
      listener: "receiveDeleteGroupChat",
      action: deleteChat,
    },
    { listener: "receiveAddNewChat", action: addChat },
    {
      listener: "receiveUpdateNewChat",
      action: receiveUpdateNewChat,
    },
    { listener: "receive_unread_count", action: receiveUnreadCount },
    ///////////////////////////////////////////////////////////////////////////
    ///////////////listeners for dbugging//////////////////////////////////////

    // {
    //   listener: "pong",
    //   action: () => {
    //     console.log("Received pong from server");
    //   },
    // },
    {
      listener: "error",
      action: (error) => {
        console.log("Socket temporary event error, ", error);
      },
    },
    {
      listener: "reconnect",
      action: (attempt) => {
        console.log("Socket temporary event reconnect, ", attempt);
      },
    },
  ];

  useEffect(() => {
    listenersArray.map((listener) => {
      socket.on(listener.listener, listener.action);
    });

    return () => {
      listenersArray.map((listener) => {
        socket.off(listener.listener, listener.action);
      });
    };
  }, [
    socket,
    slugProjectsData,
    profile,
    messageList,
    currentChat,
    chatList,
    messageCount,
    messageListPageNo,
    chatCount,
    chatType,
    useNavigate(),
  ]);
  //================Google conection////////////////////////
  const [disconnectGoogleDialogOpen, setDisconnectGoogleDialogOpen] =
    useState(false);
  const [googleConnectionLoading, setGoogleConnectionLoading] = useState(false);
  const handleConnectionWithGoogleCalendar = async () => {
    try {
      const res = await signInWithGoogle();
      if (res) {
        const { email, result } = res;
        const response = await _google_login({
          code: result.code,
          email,
          time_zone: moment.tz.guess(),
        });
        if (response.code == 200) {
          enqueueSnackbar("Syncronized with Google successfully", {
            variant: "success",
          });
          dispatch_set_user_profile(response.data.user_data);
          set_to_localStorage("user", response.data.user_data);
        } else {
          enqueueSnackbar(response.message, { variant: "error" });
        }
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      enqueueSnackbar(error, { variant: "error" });
      setGoogleConnectionLoading(false);
    }
  };
  const handleDisconnectfromGoogleCalendar = async () => {
    try {
      setGoogleConnectionLoading(true);
      const result = await _google_logout();
      if (result.code == 200) {
        setDisconnectGoogleDialogOpen(false);
        let user = dispatch_get_user_profile();
        delete user.google_account_email;
        delete user.refresh_token;
        dispatch_set_user_profile(user);
        set_to_localStorage("user", user);
        signOutFromGoogle();
        enqueueSnackbar("Disconnected from google account", {
          variant: "success",
        });
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.log(error, " catched while disconnecting from google");
    } finally {
      setGoogleConnectionLoading(false);
    }
  };
  const startLoading = () => {
    setGoogleConnectionLoading(true);
    setTimeout(() => {
      setGoogleConnectionLoading(false);
    }, 5000);
  };
  const handleLogout = () => {
    setLogoutDialogOpen(false);
    logout_user(logoutRadioValue);
    setLogoutRadioValue("0");
    setUnreadNotification(0);
    setNotificationCount(0);
    setBadge({
      chat: 0,
      invitation: 0,
      support: 0,
    });
    disconnectSocket();
    navigate("/login", { replace: true });
    setDashboardData();
    setSocket(socketIOClient());
  };
  // ------------- WorkspaceProject Timer ----------------
  const [activeTasks, setActiveTasks] = useState([]);

  const getActiveTaskList = async () => {
    const req_obj = {
      user_id: profile.user_id,
    };
    const response = await _get_active_task_list(req_obj);
    if (response.code === 200) {
      setActiveTasks(response.data);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  useEffect(() => {
    if (profile._id) {
      getActiveTaskList();
    }
  }, [profile?._id]);

  //---------------------- Tag Expand---------------------
  const storedValue = localStorage.getItem("tagExpand");
  const [tagExpand, setTagExpand] = useState(storedValue === "true");

  useEffect(() => {
    localStorage.setItem("tagExpand", tagExpand ? "true" : "false");
  }, [tagExpand]);


  useEffect(() => {
    // fetch the unread count immediately - shamroz
    if (profile && profile.user_id && socket) {
      socket.emit("send_unread_count", { user_id: profile.user_id });
    }
  }, [pathname]);

  const bundle = {
    pageTitle,
    setPageTitle,
    tagExpand,
    setTagExpand,
    activeTasks,
    getActiveTaskList,
    socket,
    disconnectGoogleDialogOpen,
    setDisconnectGoogleDialogOpen,
    googleConnectionLoading,
    setGoogleConnectionLoading,
    handleConnectionWithGoogleCalendar,
    handleDisconnectfromGoogleCalendar,
    startLoading,
    dispatch_get_user_profile,
    dispatch_set_user_profile,
    dispatch_set_plan_limits,
    dispatch_get_plan_limits,
    dispatch_set_current_plan,
    dispatch_get_current_plan,
    limitReachedDialogOpen,
    setLimitReachedDialogOpen,
    noSubscriptionDialog,
    setNoSubscriptionDialog,
    dispatch_get_search_value,
    dispatch_set_search_value,
    dispatch_get_current_selected_item,
    dispatch_set_current_selected_item,
    dispatch_get_search_visibility,
    dispatch_set_search_visibility,
    messageCount,
    setMessageCount,
    messageListPageNo,
    setMessageListPageNo,
    socketEmit,
    slugProjectsData,
    setSlugProjectsData,
    notificationCount,
    setNotificationCount,
    messageList,
    setMessageList,
    chatData,
    setChatData,
    currentChat,
    setCurrentChat,
    chatList,
    setChatList,
    chatCount,
    setChatCount,
    chatType,
    setChatType,
    getModifiedChatItem,
    chatListDrawerOpen,
    setChatListDrawerOpen,
    isOpenChatDialog,
    setIsOpenChatDialog,
    setIsOpenChatNotificationDialog,
    isOpenChatNotificationDialog,
    isMinimizeChat,
    setIsMinimizeChat,
    isUserSeeningMessage,
    setIsUserSeeningMessage,
    loadingMessageList,
    setLoadingMessageList,
    chatListLoading,
    setChatListLoading,
    badge,
    setBadge,
    disconnectSocket,
    generateUniqueIdForMessage,
    showSnackbar,
    showCustomSnackbar,
    notifications,
    setNotifications,
    count,
    setCount,
    page,
    setPage,
    loading,
    setLoading,
    getNotificationList,
    unreadNotification,
    setUnreadNotification,
    handleLogout,
    logoutDialogOpen,
    setLogoutDialogOpen,
    logoutRadioValue,
    setLogoutRadioValue,
    connectSocket,
    dashboardData,
    setDashboardData,
    key,
    setKey,
    keyLoading,
    setKeyLoading,
  };
  return <Context.Provider value={bundle}>{children}</Context.Provider>;
};

export default AppContext;
export const useAppContext = () => React.useContext(Context);
